import { createApp } from 'vue'
import {
  Button,
  Cell,
  CellGroup,
  Empty,
  Field,
  Icon,
  Image,
  List,
  Loading,
  NavBar,
  Popup,
  Radio,
  RadioGroup,
  Tabbar,
  TabbarItem,
} from 'vant'
import 'vant/lib/index.css'
import App from './App.vue'
import router from './router'

createApp(App)
  .use(router)
  .use(Button)
  .use(Cell)
  .use(CellGroup)
  .use(Empty)
  .use(Field)
  .use(Icon)
  .use(Image)
  .use(List)
  .use(Loading)
  .use(NavBar)
  .use(Popup)
  .use(Radio)
  .use(RadioGroup)
  .use(Tabbar)
  .use(TabbarItem)
  .mount('#app')
